export const ATTENDANCE_CONFIGURATION_LOAD = 'ATTENDANCE_CONFIGURATION_LOAD'
export const ATTENDANCE_CONFIGURATION_LOAD_PENDING = 'ATTENDANCE_CONFIGURATION_LOAD_PENDING'
export const ATTENDANCE_CONFIGURATION_LOAD_FULFILLED = 'ATTENDANCE_CONFIGURATION_LOAD_FULFILLED'
export const ATTENDANCE_CONFIGURATION_LOAD_REJECTED = 'ATTENDANCE_CONFIGURATION_LOAD_REJECTED'

export const ATTENDANCE_LINK_LOCATION = 'ATTENDANCE_LINK_LOCATION'
export const ATTENDANCE_LINK_LOCATION_PENDING = 'ATTENDANCE_LINK_LOCATION_PENDING'
export const ATTENDANCE_LINK_LOCATION_FULFILLED = 'ATTENDANCE_LINK_LOCATION_FULFILLED'
export const ATTENDANCE_LINK_LOCATION_REJECTED = 'ATTENDANCE_LINK_LOCATION_REJECTED'

export const ORGANIZATION_DEVICE_ROLE_CREATE = 'ORGANIZATION_DEVICE_ROLE_CREATE'
export const ORGANIZATION_DEVICE_ROLE_CREATE_PENDING = 'ORGANIZATION_DEVICE_ROLE_CREATE_PENDING'
export const ORGANIZATION_DEVICE_ROLE_CREATE_FULFILLED = 'ORGANIZATION_DEVICE_ROLE_CREATE_FULFILLED'
export const ORGANIZATION_DEVICE_ROLE_CREATE_REJECTED = 'ORGANIZATION_DEVICE_ROLE_CREATE_REJECTED'

export const ORGANIZATION_PUNCH_DEVICE_LOAD = 'ORGANIZATION_PUNCH_DEVICE_LOAD'
export const ORGANIZATION_PUNCH_DEVICE_LOAD_PENDING = 'ORGANIZATION_PUNCH_DEVICE_LOAD_PENDING'
export const ORGANIZATION_PUNCH_DEVICE_LOAD_FULFILLED = 'ORGANIZATION_PUNCH_DEVICE_LOAD_FULFILLED'
export const ORGANIZATION_PUNCH_DEVICE_LOAD_REJECTED = 'ORGANIZATION_PUNCH_DEVICE_LOAD_REJECTED'

export const ORGANIZATION_DEVICE_ROLE_DELETE = 'ORGANIZATION_DEVICE_ROLE_DELETE'
export const ORGANIZATION_DEVICE_ROLE_DELETE_PENDING = 'ORGANIZATION_DEVICE_ROLE_DELETE_PENDING'
export const ORGANIZATION_DEVICE_ROLE_DELETE_FULFILLED = 'ORGANIZATION_DEVICE_ROLE_DELETE_FULFILLED'
export const ORGANIZATION_DEVICE_ROLE_DELETE_REJECTED = 'ORGANIZATION_DEVICE_ROLE_DELETE_REJECTED'

export const REFRESH_PUNCH_DEVICE_STATUS = 'REFRESH_PUNCH_DEVICE_STATUS'
export const REFRESH_PUNCH_DEVICE_STATUS_PENDING = 'REFRESH_PUNCH_DEVICE_STATUS_PENDING'
export const REFRESH_PUNCH_DEVICE_STATUS_FULFILLED = 'REFRESH_PUNCH_DEVICE_STATUS_FULFILLED'
export const REFRESH_PUNCH_DEVICE_STATUS_REJECTED = 'REFRESH_PUNCH_DEVICE_STATUS_REJECTED'

export const PUNCH_DEVICE_STATUS = 'PUNCH_DEVICE_STATUS'
export const PUNCH_DEVICE_STATUS_PENDING = 'PUNCH_DEVICE_STATUS_PENDING'
export const PUNCH_DEVICE_STATUS_FULFILLED = 'PUNCH_DEVICE_STATUS_FULFILLED'
export const PUNCH_DEVICE_STATUS_REJECTED = 'PUNCH_DEVICE_STATUS_REJECTED'
